import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import Alert, {
  getFriendlyErrorMessage,
  getNotificationForError,
  success as successNotificationType,
  error as errorNotificationType,
} from "../Alert";
import AdminGrid, { direction } from "../AdminGrid/AdminGrid";
import { columnTypes } from "../AdminGrid/AdminGrid";
import { useHistory } from "react-router-dom";
import { deleteUrl, get } from "../../Common/api";
import { setCurrentPageNotification } from "../../redux/notificationSlice";
import getActions from "../../Common/actions";
import DeletePosRoleDialog from "./DeletePosRoleDialog";
import { orderBy } from "@progress/kendo-data-query";
import "./CustomPosRoleList.css";

export default function PosRolesList() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [posRoles, setPosRoles] = useState([]);
  const [availableActions, setavailableActions] = useState([]);
  const [isDeleteDialogDialogVisible, setIsDeleteDialogDialogVisible] =
    useState(false);
  const [assignedUserCount, setAssignedUserCount] = useState(0);
  const [selectedRoleToDelete, setSelectedRoleToDelete] = useState({});
  const actions = getActions();
  const [sort, setSort] = useState([{ field: "name", dir: direction.ASC }]);
  const canEdit =
    availableActions.filter((a) => a.name === actions.update.name).length > 0;
  const canCreate =
    availableActions.filter((a) => a.name === actions.create.name).length > 0;
  const canDelete =
    availableActions.filter((a) => a.name === actions.delete.name).length > 0;
  const getActionsForRole = (role) => {
    const myActions = [];
    const editAction = {
      title: "Edit",
      label: `Edit POS role ${role.name}`,
      onClick: (props) => history.push(`/posroles/${props.dataItem.id}`),
    };
    const deleteAction = {
      title: "Delete",
      label: `Delete pos role ${role.name}`,
      onClick: (props) => canDeletePosRole(props.dataItem),
    };
    if (canEdit) {
      myActions.push(editAction);
    }
    if (canDelete) {
      myActions.push(deleteAction);
    }
    return myActions;
  };
  const listData = orderBy(
    posRoles.map((role) => ({
      ...role,
      actions: getActionsForRole(role),
    })),
    sort
  );

  const sortChange = (event) => {
    // Do not sort by actions column
    if(event.sort.length > 0 && event.sort[event.sort.length - 1].field === 'actions') {
      return;
    }
    setSort(event.sort);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    Promise.all([
      get("/posroles").catch((error) => {
        dispatch(setCurrentPageNotification(getNotificationForError(error)));
      }),
      get("/posroles/actions").catch((error) => {
        dispatch(setCurrentPageNotification(getNotificationForError(error)));
      }),
    ]).then((values) => {
      const roles = values[0];
      if (roles) {
        setPosRoles(roles);
      }
      const actions = values[1];
      if (actions) {
        setavailableActions(actions);
      }
    });
  }, [dispatch]);

  const canDeletePosRole = async (posRole) => {
    try {
      const userCount = await get(
        `/posroles/${posRole.id}/CanDelete`,
        "Failed to check for pos assignment"
      );
      setAssignedUserCount(userCount);
      setSelectedRoleToDelete(posRole);
      setIsDeleteDialogDialogVisible(true);
    } catch (error) {
      dispatch(setCurrentPageNotification(getNotificationForError(error)));
    }
  };

  const onCancel = async () => {
    setIsDeleteDialogDialogVisible(false);
  };

  const onDelete = async (posRole) => {
    try {
      await deleteUrl(
        `/posroles/${posRole.id}`,
        "Failed to delete the POS role"
      );
      const posRolesFiltered = posRoles.filter(
        (m) => m.id != posRole.id
      );
      setPosRoles(posRolesFiltered);
      dispatch(
        setCurrentPageNotification({
          type: successNotificationType,
          message: `POS role ${posRole.name} has been deleted.`,
        })
      );
    } catch (error) {
      dispatch(setCurrentPageNotification(getNotificationForError(error)));
    }
    setIsDeleteDialogDialogVisible(false);
  };

  const columns = [
    {
      field: "name",
      title: "Name",
    },
    {
      field: "actions",
      title: "Actions",
      type: columnTypes.actions,
    },
  ];

  return (
    <React.Fragment>
      <Alert />
      {isDeleteDialogDialogVisible && (
        <DeletePosRoleDialog
          assignedUsersCount={assignedUserCount}
          posRole={selectedRoleToDelete}
          onCancel={onCancel}
          onDelete={onDelete}
        ></DeletePosRoleDialog>
      )}
      <div className="row">
        <div className="col-md-12">
          <h2>POS Roles</h2>
          <ul className="page-breadcrumb breadcrumb">
            <li>
              <i className="fa fa-user fa-fw"></i>
              <Link to="/posroles">Security</Link>
              <i className="fa fa-angle-right"></i>
            </li>
            <li>
              <Link to="/posroles">POS Roles</Link>
            </li>
          </ul>
        </div>
      </div>
      {canCreate && (
        <div className="row MarginBottomDiv">
          <div className="col-md-12 ">
            <div className="btn-group pull-left">
              <Link to="/posroles/new" className="ActionLink">
                <div id="sub-div">
                  <button
                    id="AddNewButton"
                    className="btn green"
                    style={{ width: "200px", marginBottom: "20px" }}
                  >
                    Add New POS Role
                  </button>
                </div>
              </Link>
            </div>
          </div>
        </div>
      )}
      <div data-testid="thegridcontainer">
        <AdminGrid
          columns={columns}
          data={listData}
          sortable={{ allowUnsort: false }}
          sort={sort}
          sortChange={sortChange}
        />
      </div>
    </React.Fragment>
  );
}
